import { axiosBase } from '@/api/api'
export default {
  data () {
    return {
      props: {
        children: "children",
        label: "label",
        isLeaf: "isLeaf"
      },
      // 控制加载
      loading: true
    }
  },
  methods: {
    async loadNode (node, resolve) {
      this.loading = true
      if (node.level === 0) {
        if (this.isSpace) {
          resolve([this.curSpaceInfo])
          this.defaultShowNodes.push(this.spaceid)
          this.loading = false
        } else {
          this.getOrganization().then(res => {
            console.log(res,'resresres')
            resolve(res)
          })
        }
      } else {
        this.getOrganization(node.data.organizationId).then(res => {
          resolve(res)
        })
      }
    },
    async getOrganization (pid = 0) {
      // 获取组织管理内容
      const obj = { curpage: 0, pagesize: 0, pid }
      if (this.isSpace && this.spaceid) {
        obj.spaceid = this.spaceid
      }
      console.log('走这边吗，',this.isSpace,this.spaceid);
      const { data, code } = await axiosBase(obj,"/api/getorganizationlist")
      if (code === 0) {
        this.loading = false
        return data
      } else {
        console.log('getdeptlist请求错误');
      }
    },

    // 获取角色信息
    async loadNodeRole (node, resolve) {

      this.loading = true
      if (node.level === 0) {
        this.getRole().then(res => {
          resolve(res)
        })
      } else {
        this.getRole(node.data.roleId).then(res => {
          resolve(res)
        })
      }
    },
    async getRole(pid = 0){
      const parm = {
        curpage: 0,
        pagesize: 0,
        pid
      }
      if (this.isSpace && this.spaceid) {
        parm.spaceid = this.spaceid
      }
      const { data, code } = await axiosBase(
        parm,
        "/api/getrolelist"
      )
      if (code === 0) {
        this.loading = false
        return data
      } else {
        console.log('getrolelist');
      }
    }
  },
}